/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { AppsService } from '../services/apps.service';

@Component({
  selector: 'display-resource',
  templateUrl: './display-resource.component.html',
  styleUrls: ['./display-resource.component.less'],
  standalone: false,
})
export class DisplayResourceComponent implements OnInit {
  content = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private appsService: AppsService,
  ) {}

  ngOnInit() {
    this.activatedRoute.url.subscribe((urlSegments) => {
      const lastUrlSegment = urlSegments[urlSegments.length - 1].path;
      switch (lastUrlSegment) {
        case 'terms':
        default:
          this.getTOU();
      }
    });
  }

  async getTOU() {
    const userId = this.userService?.user?.id ?? '';
    await this.appsService
      .getTOU(userId)
      .then((resp) => {
        this.content = resp;
      })
      .catch((err) => console.log(err));
  }
}
